var _path, _path2, _path3, _line, _line2, _path4, _rect, _path5, _path6, _line3, _line4, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakingIncome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13C7 17 17 16.5 18 13",
    stroke: "#68F4C9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17C7 21 17 20.5 18 17",
    stroke: "#68F4C9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21C7 25 17 24.5 18 21",
    stroke: "#24D1A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 21.0417,
    x2: 18,
    y2: 9.00015,
    stroke: "#24D1A8",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 21.0417,
    x2: 5,
    y2: 9.00015,
    stroke: "#24D1A8",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 9.55546 17.5614 10.2908 16.3327 10.9461C15.147 11.5784 13.4402 12 11.5 12C9.55984 12 7.85296 11.5784 6.66729 10.9461C5.43864 10.2908 5 9.55546 5 9C5 8.44454 5.43864 7.7092 6.66729 7.05393C7.85296 6.42157 9.55984 6 11.5 6C13.4402 6 15.147 6.42157 16.3327 7.05393C17.5614 7.7092 18 8.44454 18 9Z",
    stroke: "#0BC196",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 11,
    height: 12,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21C15 25 25 24.5 26 21",
    stroke: "#68F4C9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C15 29 25 28.5 26 25",
    stroke: "#24D1A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 25,
    x2: 26,
    y2: 17,
    stroke: "#24D1A8",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 25,
    x2: 13,
    y2: 17,
    stroke: "#24D1A8",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17C26 17.5555 25.5614 18.2908 24.3327 18.9461C23.147 19.5784 21.4402 20 19.5 20C17.5598 20 15.853 19.5784 14.6673 18.9461C13.4386 18.2908 13 17.5555 13 17C13 16.4445 13.4386 15.7092 14.6673 15.0539C15.853 14.4216 17.5598 14 19.5 14C21.4402 14 23.147 14.4216 24.3327 15.0539C25.5614 15.7092 26 16.4445 26 17Z",
    stroke: "#0BC196",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingIncome);
export default __webpack_public_path__ + "static/media/stakingIncome.366e39af25803f6dded89179d8ea305a.svg";
export { ForwardRef as ReactComponent };